import { MenuProps } from './menu';

/** 模拟异步路由，本地路由有bug（点击标签页切换页面时导致页面多次刷新） */
export const TempMenus: MenuProps[] = [
  {
    id: 1,
    name: 'record',
    title: '废弃物记录',
    path: '/record',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
    children: [
      {
        id: 11,
        name: 'wasteRecord',
        title: '项目废弃物记录',
        path: '/record/wasteRecord',
        component: '@/pages/record/wasteRecord',
        renderMenu: true,
        parent: 'record',
        permission: null,
        cacheable: true,
      },
    ],
  },
  {
    id: 4,
    name: 'assetsManage',
    title: '废旧物资台账',
    path: '/assetsManage',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
    children: [
      {
        id: 41,
        name: 'assetsManageRecord',
        title: '废旧物资记录',
        path: '/assetsManage/assetsManageRecord',
        component: '@/pages/assetsManage/assetsManageRecord',
        renderMenu: true,
        parent: 'assetsManage',
        permission: null,
        cacheable: true,
      },
    ],
  },
  {
    id: 2,
    name: 'setting',
    title: '基础设置',
    path: '/setting',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
    children: [
      {
        id: 21,
        name: 'standardSetting',
        title: '分类标准设置',
        path: '/setting/standardSetting',
        component: '@/pages/setting/standardSetting',
        renderMenu: true,
        parent: 'setting',
        permission: 'is_admin',
        cacheable: true,
      },
      {
        id: 22,
        name: 'projectSetting',
        title: '项目设置',
        path: '/setting/projectSetting',
        component: '@/pages/setting/projectSetting',
        renderMenu: true,
        parent: 'setting',
        permission: null,
        cacheable: true,
      },
      {
        id: 23,
        name: 'userSetting',
        title: '用户设置',
        path: '/setting/userSetting',
        component: '@/pages/setting/userSetting',
        renderMenu: true,
        parent: 'setting',
        permission: null,
        cacheable: true,
      },
      {
        id: 24,
        name: 'assetsSetting',
        title: '废旧物资设置',
        path: '/setting/assetsSetting',
        component: '@/pages/setting/assetsSetting',
        renderMenu: true,
        parent: 'setting',
        permission: 'is_admin',
        cacheable: true,
      },
    ],
  },
  {
    id: 3,
    name: 'chart',
    title: '统计图表',
    path: '/chart',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
    children: [
      {
        id: 31,
        name: 'projectMonthlyWasteRecord',
        title: '项目月度废弃物记录',
        path: '/chart/projectMonthlyWasteRecord',
        component: '@/pages/chart/projectMonthlyWasteRecord',
        renderMenu: true,
        parent: 'chart',
        permission: null,
        cacheable: true,
      },
      {
        id: 32,
        name: 'wasteVisualChart',
        title: '年度废弃物可视化报表',
        path: '/chart/wasteVisualChart',
        component: '@/pages/chart/wasteVisualChart',
        renderMenu: true,
        parent: 'chart',
        permission: null,
        cacheable: true,
      },
      {
        id: 33,
        name: 'monthWasteVisualChart',
        title: '月度废弃物可视化报表',
        path: '/chart/monthWasteVisualChart',
        component: '@/pages/chart/monthWasteVisualChart',
        renderMenu: true,
        parent: 'chart',
        permission: null,
        cacheable: true,
      },
      {
        id: 34,
        name: 'assetsRecord',
        title: '年度废旧物资记录',
        path: '/chart/assetsRecord',
        component: '@/pages/chart/assetsRecord',
        renderMenu: true,
        parent: 'chart',
        permission: null,
        cacheable: true,
      },
    ],
  },
];
